export default __webpack_public_path__ + "img/cZQMxHAP.6441aa98.svg";